import { supabase } from '@/integrations/supabase/client';

/**
 * Enterprise audit trail utility.
 * Writes structured entries to the audit_log table for compliance & forensics.
 */

type AuditAction =
  | 'invoice.approved'
  | 'invoice.blocked'
  | 'invoice.deleted'
  | 'match.confirmed'
  | 'match.bulk_confirmed'
  | 'transaction.deleted'
  | 'transaction.bulk_deleted'
  | 'alert.resolved'
  | 'alert.dismissed'
  | 'account.deleted'
  | 'profile.updated'
  | 'password.changed'
  | 'settings.updated'
  | 'export.generated';

type ResourceType =
  | 'invoice'
  | 'bank_transaction'
  | 'tally_entry'
  | 'match'
  | 'alert'
  | 'profile'
  | 'settings'
  | 'report';

interface AuditEntry {
  action: AuditAction;
  resource_type: ResourceType;
  resource_id?: string;
  details?: Record<string, unknown>;
}

export async function writeAuditLog(entry: AuditEntry): Promise<void> {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.user?.id) return;

    await supabase.from('audit_log').insert([{
      user_id: session.user.id,
      action: entry.action,
      resource_type: entry.resource_type,
      resource_id: entry.resource_id ?? null,
      details: (entry.details as any) ?? null,
      user_agent: navigator.userAgent,
    }]);
  } catch {
    // Audit logging should never break the user flow
    console.warn('Audit log write failed silently');
  }
}
